<template>
  <el-table
    ref="multipleTable"
    class="radish-project-list"
    :data="list"
    size="mini"
    border
    style="width:521px;"
    height="300px"
    tooltip-eff0-ect="dark"
    highlight-current-row
    @current-change="handleCurrentChange"
  >
    <el-table-column prop="姓名" label="姓名" width="80">
      <template slot-scope="scope">
        <el-badge :hidden="!scope.row.badge" is-dot>
          <a class="company-pointer ft14" @click="showRadishDetail(scope.row.rid)">{{
            scope.row.radish && scope.row.radish.姓名
          }}</a>
        </el-badge>
      </template>
    </el-table-column>
    <el-table-column prop="性别" label="性别" width="80">
      <template slot-scope="scope">
        <span class="ft14">{{ scope.row.radish && scope.row.radish.性别 }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="目前公司" label="目前公司" width="80">
      <template slot-scope="scope">
        <span class="ft14">{{ scope.row.radish && scope.row.radish.公司 }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="目前职位" label="目前职位" width="80">
      <template slot-scope="scope">
        <span class="ft14">{{ scope.row.radish && scope.row.radish.目前职位 }}</span>
      </template>
    </el-table-column>

    <el-table-column label="人选进展阶段" width="120">
      <template slot-scope="scope">
        <div class="radish-btn radish-btn-primary" style="padding: 0px 20px;" @click="showRadishProgress(scope.row)">
          {{ scope.row.状态.tag }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="邮件" v-if="step !== '寻访沟通'">
      <template slot-scope="scope">
        <span
          style="color:#67C23A"
          v-if="scope.row.已绑定推荐报告 && scope.row.已绑定推荐报告.length && scope.row.已绑定推荐报告.length > 0"
        >
          有附件
        </span>
        <el-tooltip effect="dark" content="您是否没有发邮件给客户公司，请补充" placement="top-start">
          <span
            style="color:#F56C6C"
            v-if="
              !scope.row.已绑定推荐报告 || !scope.row.已绑定推荐报告.length || scope.row.已绑定推荐报告.length === 0
            "
          >
            无附件</span
          >
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="更新时间" width="100">
      <template slot-scope="scope">
        <span class="ft14">{{ dateFormat(scope.row.updatedAt, 'yyyy-mm-dd') }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    project: { type: Object, default: () => ({}) },
    step: { type: String, default: '' },
  },
  data() {
    return {
      list: [],
      stepMap: {
        职位推荐: '已推荐',
        面试阶段: '面试',
        offer谈判: 'offer',
        离职管理: '到岗',
      },
    }
  },
  watch: {
    'project.radish_project': {
      handler(newValue, oldValue) {
        this.getList()
      },
      immediate: true,
    },
    step: {
      handler(newValue, oldValue) {
        this.getList()
      },
      immediate: true,
    },
  },
  methods: {
    showRadishProgress(row) {
      this.$emit('showRadishProgress', row)
    },
    removeRow(row) {
      this.list = this.list.filter(val => val._id !== row._id)
      this.setCurrent(this.list[0])
    },
    setCurrent(row) {
      row && this.$refs.multipleTable && this.$refs.multipleTable.setCurrentRow(row)
      // this.$emit('currentRow', val)
    },
    handleCurrentChange(val) {
      this.currentRow = val
      if (val.badge) {
        this.$set(val, 'badge', false)
        this.updateStorage(val)
      }
      val.badge = false
      this.$emit('currentRow', val)
    },
    getStorage() {
      const storage = localStorage.getItem('radishProjectHistory')
      const obj = (storage && JSON.parse(storage)) || {}

      this.radishProjectStorage = obj
    },
    updateStorage(val) {
      this.radishProjectStorage[`${val.pid}${val.rid}`] = val.修改历史 || {}
      localStorage.setItem('radishProjectHistory', JSON.stringify(this.radishProjectStorage))
    },
    async getList() {
      this.getStorage()
      const { radishProjectStorage } = this
      const filterVal = this.stepMap[this.step]
      const radishProject = this.project.radish_project || []
      console.log('getList -> radishProject111', radishProject)

      const list = radishProject.filter(
        v => v.状态 && v.状态.tag === filterVal && v.状态.detail !== '淘汰' && v.状态.detail !== '放弃',
      )
      const res = await app.service('radish').findByIds({ ids: list.map(item => item.rid) })
      if (res.status === 'success') {
        list.forEach(ele => {
          ele.radish = res.data.find(v => v._id === ele.rid)
        })
      }
      this.list = list
      this.list.forEach(val => {
        if (val[`修改历史`]) {
          if (
            JSON.stringify(val[`修改历史`] || {}) !== JSON.stringify(radishProjectStorage[`${val.pid}${val.rid}`] || {})
          ) {
            this.$set(val, 'badge', true)
          }
        } else this.$set(val, 'badge', true)
      })
      this.setCurrent(this.list[0])
      this.loading = false
    },
    showRadishDetail(rid) {
      window.open(`${window.frontend}/#/radish-detail-blank/${rid}?p=${this.project._id}`, '_blank')
    },
    dateFormat(time, format) {
      return dateFormat(time, format)
    },
  },
}
</script>
<style>
.radish-project-list .cell {
  padding-top: 5px;
}
</style>
<style scoped>
.bolder {
  font-weight: 700;
}
.ft14 {
  font-size: 14px;
}
</style>
